import { MyMap } from "../../components/Map";
import { MainLayout } from "../../Layout";

export const Home = () => {
  return (
    <MainLayout>
      <MyMap />
    </MainLayout>
  );
};
